module.exports = __webpack_public_path__ + "img/nigami.85accfbb.svg";